module.exports = __webpack_public_path__ + "static/1159091878-exit.69aba3c4.jpg";